export const VALUES = {
    TODAY: 'today',
    TODAY_ACTIVE: 'todayActive',
    TOMORROW: 'tomorrow',
    TODAY_EXPIRED: 'todayExpired',
    TOMORROW_ACTIVE: 'tomorrowActive',
} as const;
